export default __webpack_public_path__ + "static/media/g16.b37ef6ed.jpg";